import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ShiftsImportQueryCgResponse,
  ShiftsImportQueryVariables,
} from '@common/graphql/schema';

export type ImportShiftsProgressQueryResponse = {
  shiftGapImport: {
    id: string;
    pending: boolean;
    state: string;
  };
};

export type ImportShiftsProgressQueryVariables = {
  id: string;
};

export const ImportShiftsProgressQuery: TypedDocumentNode<
  ShiftsImportQueryCgResponse,
  ShiftsImportQueryVariables
> = gql`
  query ShiftsImport($id: ID!) {
    shiftGapImport(id: $id) {
      id
      pending
      state
    }
  }
`;
